__webpack_require__.p = "https://bmidxbdenmarkplpreprod.netlify.app/";